export const SIX_MONTHS_FINANCING_MODAL_ID = 'sixPaymentsModalContent'
export const TWELVE_MONTHS_FINANCING_MODAL_ID = 'twelvePaymentsModalContent'
export const SIX_MONTHS = '6'
